// The backend is inconsistent with naming, and turning back and forth between casing in the function itself
//  makes the function more complex, so for now we are just adding the values we see here
const bannedHeaders: string[] = [
  'Departure_sort',
  'departure_sort',
  'Arrival_sort',
  'arrival_sort',
  'id',
  'ID',
  'Id',
  'Date_sort',
  'date_sort',
  'DATE_SORT',
  'ATA_sort',
  'ATD_sort',
  'Begin_sort',
  'begin_sort',
  'End_sort',
  'end_sort',
  'Exit_sort',
  'exit_sort',
  'Enter_sort',
  'enter_sort',
  'Timestamp_sort',
  'timestamp_sort',
  'ACTTS', // A date field in watchdog that's already displayed with a different name
  'Actts',
  'actts',
  'DEATS', // A date field in watchdog that's already displayed with a different name
  'Deats',
  'deats',
  'ata_sort',
  'atd_sort',
  'Dats_sort',
  'dats_sort',
  'SDATS_sort',
  'sdats_sort',
  'EDATS_sort',
  'edats_sort',
  'CPAT_sort',
  'Cpat_sort',
  'cpat_sort',
  'ETA_sort',
  'Eta_sort',
  'eta_sort',
  'ACT_sort',
  'Act_sort',
  'act_sort',
  'DEA_sort',
  'Dea_sort',
  'dea_sort',
  'sta_sort',
  'Sta_sort',
  'STA_sort',
  'std_sort',
  'Std_sort',
  'STD_sort',
];

export function filterTableHeaders(headers: string[]): string[] {
  const result: string[] = [];

  headers.forEach((header) => {
    if (!bannedHeaders.includes(header)) {
      result.push(header);
    }
  });

  return result;
}
